@import "@/styles/variables";

.row_global_card {
	margin-right: 5px !important;
	margin-left: 5px !important;
	margin-top: 5px;
	height: 100%;

	@media screen and (max-width: 950px) {
		margin-right: 10px !important;
		margin-left: 10px !important;

		margin-bottom: 3em;
	}

	.col_base {
		margin-bottom: 10px;
		padding-right: 0px;
		padding-left: 0px;

		@media screen and (max-width: 950px) {
			max-height: initial;
			min-height: initial;
		}

		.header {
			height: 42%;
			animation: fade-in 1s;

			&.collapse {
				height: 0%;
			}

			.headerRight {
				border-left: 0.5px solid #d3d3d3;
				padding-left: 0px;
				padding-right: 0px;

				@media screen and (max-width: 950px) {
					border-left: 0px solid white;
				}
			}

			.divider {
				height: 2px;
				width: 100%;
				display: block; /* for use on default inline elements like span */
				margin: 9px 0;
				overflow: hidden;
				background-color: #e5e5e5;
			}

			.headerLeft {
				border-right: 0.5px solid #d3d3d3;
				padding-left: 0px;
				padding-right: 0px;

				@media screen and (max-width: 950px) {
					border-right: 0px solid white;
				}
			}

			@media screen and (max-width: 950px) {
				height: initial;
			}
		}

		.header_table {
			height: 5%;

			@media screen and (max-width: 750px) {
				display: none;
			}

			@media screen and (max-width: 950px) {
				height: initial;
			}
		}

		.body_table {
			height: 53%;
			// overflow-y: auto;

			&::-webkit-scrollbar {
				width: 5px;
				height: 5px;
			}

			&::-webkit-scrollbar-track {
				background: #f1f1f1;
			}

			&::-webkit-scrollbar-thumb {
				background-color: #a8a8a8;
				border-radius: 15px;
			}
		}

		.divInput {
			// border: 1px solid #d3d3d3;
			padding: 0.5em;
			height: 100%;

			.distributionAfter {
				padding: 5px 10px;
				text-align: center;
				border: 1px solid #81ba43;
				border-radius: 5px;
				color: #81ba43;
				cursor: pointer;
				margin-bottom: 5px;
				margin-top: 5px;
				transition:
					background-color 0.3s,
					color 0.3s,
					transform 0.1s;

				&:hover {
					background-color: #81ba43;
					color: white;
				}

				&.pressed {
					background-color: #81ba43;
					color: white;
					transform: scale(0.95);
					box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
				}
			}

			.inputForm {
				margin-bottom: 10px;

				.inputText {
					font-size: 14px;
					margin-bottom: 2px;
					color: #5e5e5e;
				}

				.inputValue {
					width: 100%;
					padding: 5px;
					border-radius: 5px;
					border: none;
					background-color: #f3f3f3;
				}
			}
		}

		.tableHead {
			margin-bottom: 0px;

			th {
				padding-top: 5px;
				padding-left: 2px;
				padding-right: 2px;
				font-size: 12px;
				font-weight: 500;
				border: none;
				color: #5e5e5e;
			}

			.productLabel {
				text-align: end;
				border: #d7373f !important;
				color: #2977ca;
			}
		}

		.tableBody {
			tr {
				td {
					&.singleValue {
						padding-top: 13px;
						width: 6%;
						text-align: center;
						font-weight: bold;

						.eyeIcon {
							width: 27px;
							height: 27px;
						}
					}

					span {
						cursor: pointer;
					}
				}
			}
		}

		.tableDetail {
			th {
				padding-top: 5px;
				padding-left: 2px;
				padding-right: 2px;

				font-size: 12px;
				font-weight: 500;
				border: none;
				color: #5e5e5e;
			}

			.tableDetailHead {
				display: none;

				@media screen and (max-width: 750px) {
					display: contents;
				}

				.headTh {
					padding: 10px 5px;
					font-size: 11px;
				}
			}

			td {
				padding-top: 5px;
				padding-left: 2px;
				padding-right: 2px;
			}

			@media screen and (max-width: 750px) {
				overflow-x: auto;
				width: 60em;
			}
		}

		.files {
			.row_file {
				border-bottom: 1px solid #81ba43;
				padding-bottom: 5px;

				.file_number {
					@media screen and (max-width: 950px) {
						display: none;
					}
				}

				.file_name {
					cursor: pointer;

					&:hover {
						color: #2977ca;
					}
				}

				.delete_file {
					width: 1em;
					height: 1em;
					cursor: pointer;
				}
			}
		}
	}

	.total {
		text-align: right;
		font-size: 17px;

		@media screen and (max-width: 950px) {
			font-size: 20px;
		}
	}

	.iconAdd {
		width: 1.5em;
		height: 1.5em;
		cursor: pointer;
	}

	.div_calculate_machined {
		display: flex;
		flex-direction: column;
		float: right !important;

		.text_calculate_machined {
			margin-top: 5px;
			font-size: 13px;
			margin-bottom: 5px;
			color: #5e5e5e;
			max-width: 24em;
		}
	}

	.container {
		width: 100%;
	}

	.buttons {
		display: flex;
		justify-content: space-between;
		align-items: center;
		flex-wrap: wrap;
		gap: 1rem;
		margin-bottom: 20px;

		.buttonGroup {
			display: flex;
			gap: 0.5rem;
			flex-wrap: wrap;
		}

		button {
			display: flex;
			align-items: center;
			justify-content: center;
			gap: 0.5rem;
			width: 15%;
			min-width: 140px;
			padding: 0.5rem 1rem;
			border: none;
			color: white;
			transition:
				background-color 0.3s,
				color 0.3s,
				transform 0.1s;
			border-radius: 5px;
			cursor: pointer;

			&:hover {
				transform: scale(1.02);
			}

			&:disabled {
				opacity: 0.6;
				cursor: not-allowed;
			}
		}

		.buttonClose {
			background-color: #d7373f;

			&:hover {
				background-color: #b32a2f;
			}
		}

		.buttonSave {
			background-color: #5a8217;

			&:hover {
				background-color: #4a6f14;
			}
		}

		@media screen and (max-width: 950px) {
			flex-direction: column;
			align-items: center;

			button {
				width: 100%;
			}
		}
	}
}

.iconRemove {
	width: 1.5em;
	height: 1.5em;
	cursor: pointer;
}

.addOptionBtn {
	margin-left: 10px !important;
	width: 1.5em !important;
	height: 1.5em !important;
	display: flex !important;
	align-items: center !important;
	justify-content: center !important;
	margin-top: 8.5px !important;
	background-color: white !important;
	color: #5a8217 !important;
	border: 1px solid #5a8217 !important;

	&:hover {
		background-color: #5a8217 !important;
		color: white !important;
	}
}

.productRow {
	display: flex;
	flex-direction: column;
	gap: 6px;
}

.topRow {
	display: flex;
	align-items: center;
	gap: 8px;
}

.selectWrap {
	flex: 1 1 auto;
}

.iconWrap {
	flex: 0 0 auto;
	display: flex;
	align-items: center;
}

.alternativesRow {
	width: 100%;
}

.productSelect {
	font-size: 15px;
}

.optionProduct {
	font-size: 13px;
	text-align: right;
	text-decoration: underline;
	cursor: pointer;

	&:hover {
		color: #2977ca;
	}
}
